<template>
  <div>
    <string v-bind="$attrs" v-on="$listeners" multiline ref="input" />
  </div>
</template>

<script>
/**
 * @fileoverview Config input field for paragraphs
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import string from "./string";

export default {
  name: "ParagraphField",
  components: { string },
  methods: {
    validate() {
      return this.$refs.input.validate();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>